import { mapActions, mapGetters } from "vuex";
import { getCurrentUser } from "@/services/auth";

export default {
    ...mapGetters({
        getCurrentUser: 'getCurrentUser'
    }),
    mounted() {
        this.setIsLoading(true)
        getCurrentUser()
            .then(({ data }) => this.setCurrentUser(data))
            .catch(({ message }) => this.setSnackbarError(message))
            .finally(() => this.setIsLoading(false))
    },
    methods: {
        ...mapActions({
            setCurrentUser: 'setCurrentUser',
            setSnackbarError: 'setSnackbarError',
            setIsLoading: 'setIsLoading'
        })
    }
}